/**
 * Created by Jasmine on 2018/9/26.
 */

import {observable} from "mobx";
import {request, apis} from '../../../utils/net';
import moment from 'moment'
import Modal from 'antd/lib/modal';

const store = observable({
    // 查询form
    formData: {
        begin_at: moment().startOf('month').unix(),         //起始时间戳
        end_at: moment().unix(),          //终止时间戳
        buyer_title: '',
        tax_code: '',           //销方信息:税号
        order_amount: '',       //订单总金额
        buyer_title_type: '',   //1:个人及政府事业机构,2:企业
        examine_status: '0',         //状态
        invoice_style: "",
        hotel_isset_time: 0, // 是否有设置取票时间，0.全部；1.预约请求
    },

    invoiceList: [],
    currentPage: 1,
    total: 0,

    // 商品列表
    goodsList: [],
    page: 1,
    fetchGoodsTotal: 0,

    // 查询列表
    formList: {
        checkinName: '',
        roomNo: ''
    },

    // 获取列表
    getInvoiceList(page, page_size = 10) {
        return request({
            url: apis.getBillingRecords,
            method: 'POST',
            data: {
                ...this.formData,
                page: page || this.currentPage,
                page_size
            },
            ext: {
                //没有权限，请先完成设置
                codes: ['2', '3', '4'],
                handle: (res) => {
                    let url = "/home";
                    if(res.code == "3"){
                        url = "/manage-center/menu-code/code-manage";
                    } else if(res.code == "4") {
                        url = "/home/sys-setup?edit=true";
                    }

                    Modal.warning({
                        title: '提示',
                        content: res.message,
                        onOk() {
                            history.push(url);
                        }
                    });
                }
            }
        }).then(res => {
            this.invoiceList = res.list
            this.currentPage = res.page
            this.total = +res.total_count
        })
    },

    // 获取商户水单详情
    getOrderDetailOpen(parameter){
        return request({
            url: apis.getOrderDetail,
            method: 'get',
            data: {'sale_id': parameter}
        })
    },

    // 拒绝弹窗确定
    getPostReject(parameter){
        return request({
            url: apis.postReject,
            method: 'post',
            data: parameter
        }).then(res => {
            this.getInvoiceList()
        })
    },


    /**
     * 获取商户商品列表
     * @param  {Object} params          请求参数
     * @param  {Number} currentPage     当前分页页码
     * @return {Promise}                返回一个Promise对象
     */
    fetchGoodsList(page, page_size = 10) {
        return request({
            url: apis.getOrderPage,
            data: {
                ...this.formList,
                page: page || this.page,
                page_size
            }
        }).then(res => {
            this.goodsList = res.order_list
            this.page = +res.page_index
            this.fetchGoodsTotal = +res.total_count
        })
    },

    formListChenge(parameter){
        this.formList = parameter
    },

    pageChenge(parameter){
        this.page = parameter
    }
 
})

export default store;
